export const getPageQuery = () => {
    let pathArgs = window.location.search
    if (!!pathArgs && pathArgs.startsWith('?')) {
        pathArgs = pathArgs.slice(1, pathArgs.length)
        return Object.fromEntries(pathArgs.split('&').map(i => i.split('=')))
    } else {
        return {}
    }
}
